import { memo, useState } from 'react'
import { Grid, Box, styled } from '@mui/material'
import { CardFooterItemProps } from './CardFooterInterfaces'
import CardFooterItemIcon from './CardFooterItemIcon'
import CardFooterItemText from './CardFooterItemText'

const Root = styled(Grid)(({ theme }) => ({
  flexWrap: 'nowrap',
  alignItems: 'center',
  color: theme.palette.text.primary,
  width: 'auto',

  '& + .CardFooterItem': {
    marginLeft: theme.spacing(1.5),

    '&:before': {
      content: '""',
      height: theme.spacing(3),
      borderLeft: `1px solid ${theme.palette.divider}`,
      marginRight: theme.spacing(1.5)
    }
  }
}))

function CardFooterItem(props: CardFooterItemProps) {
  const [showIconTooltip, setShowIconTooltip] = useState(false)
  const [showTextTooltip, setShowTextTooltip] = useState(false)

  return (
    <Root container className="CardFooterItem">
      <Box
        {...(props.tooltip && {
          onMouseEnter: () => {
            setShowIconTooltip(true)
          },
          onMouseLeave: () => {
            setShowIconTooltip(false)
          }
        })}
      >
        <CardFooterItemIcon {...{ ...props, showIconTooltip }} />
      </Box>

      <Box
        sx={{ whiteSpace: 'nowrap' }}
        {...(props.tooltipText && {
          onMouseEnter: () => {
            setShowTextTooltip(true)
          },
          onMouseLeave: () => {
            setShowTextTooltip(false)
          }
        })}
      >
        <CardFooterItemText {...{ ...props, showTextTooltip }} />
      </Box>
    </Root>
  )
}

export default memo(CardFooterItem)
